<template>
  <v-col
    sm="8"
    cols="12"
  >
    <v-row>
      <v-col
        sm="5"
        cols="12"
      >
        <ul class="footer-menu">
          <li class="footer-menu__title">
            {{ menus.corporate.title }}
          </li>

          <ul>
            <li
              v-for="(child, index) in availableCorporateMenuChildren"
              :key="index"
              class="footer-menu__items"
            >
              <a :href="child.link">{{ child.text }}</a>
            </li>
          </ul>
        </ul>
      </v-col>

      <v-col
        cols="5"
      >
        <ul class="footer-menu">
          <li class="footer-menu__title">
            {{ menus.more.title }}
          </li>

          <ul>
            <li
              v-for="(child, index) in availableMoreMenuChildren"
              :key="index"
              class="footer-menu__items"
            >
              <a :href="child.link">{{ child.text }}</a>
            </li>
          </ul>
        </ul>
      </v-col>

      <TheFooterLogo/>
    </v-row>
  </v-col>
</template>

<script>
  import TheFooterLogo from './TheFooterLogo.vue'

  export default {
    name: 'TheFooterMenu',

    components: {
      TheFooterLogo,
    },

    computed: {
      locale() {
        return this.$store.state.locale
      },

      menus() {
        const { locale } = this
        return {
          corporate: {
            title: this.$t('footer.menu.corporate.title'),
            children: [
              {
                text: this.$t('footer.menu.corporate.items.about'),
                link: `https://www.lausanne-tourisme.ch/${locale}/a-propos/`,
              },
              {
                text: this.$t('footer.menu.corporate.items.members'),
                link: `https://www.lausanne-tourisme.ch/${locale}/espace-membres/`,
              },
              {
                text: this.$t('footer.menu.corporate.items.jobs'),
                link:`https://www.lausanne-tourisme.ch/${locale}/jobs/`,
              },
              {
                text: this.$t('footer.menu.corporate.items.terms'),
                link: `https://www.lausanne-tourisme.ch/${locale}/terms-condition-website/`,
              },
              {
                text: this.$t('footer.menu.corporate.items.privacy'),
                link: `https://www.lausanne-tourisme.ch/${locale}/privacy-notice/`,
              }
            ]
          },
          more: {
            title: this.$t('footer.menu.more.title'),
            children: [
              {
                text: this.$t('footer.menu.more.items.meetings'),
                link: `https://www.lausanne-tourisme.ch/${locale}/business/`,
              },
              {
                text: this.$t('footer.menu.more.items.congress'),
                link: `https://www.lausanne-montreux-congress.ch/${locale}`,
              },
              {
                text: this.$t('footer.menu.more.items.trade'),
                link: `https://www.lausanne-tourisme.ch/${locale}/trade/`,
              },
              {
                text: this.$t('footer.menu.more.items.press'),
                link: `https://www.lausanne-tourisme.ch/${locale}/press/`,
              },
              {
                text: this.$t('footer.menu.more.items.advertisers'),
                link: `https://www.lausanne-tourisme.ch/${locale}/annonceurs-lausanne-tourisme/`,
              },
              {
                text: this.$t('footer.menu.more.items.brochures'),
                link: `https://www.lausanne-tourisme.ch/${locale}/brochures-guides/`,
              }
            ]
          }
        }
      },

      availableCorporateMenuChildren() {
        return this.menus.corporate.children.filter((child) => !!child.text)
      },

      availableMoreMenuChildren() {
        return this.menus.more.children.filter((child) => !!child.text)
      }
    }
  }
</script>

<style lang="sass" scoped>
  ul
    list-style-type: none
    padding-left: 0

  li
    padding: 0

  .footer-menu
    margin-bottom: 20px

    &__title
      font-size: 16px
      font-weight: bold
      padding-bottom: 10px

    &__items a
      color: #fff
      text-decoration: none

      &:hover
        opacity: 0.8
</style>
